import React, { useState, useEffect } from "react";
import styles from "./Karussell.module.css";

import wedding1 from "../../assets/images/Karussell/wedding1.avif";
import wedding5 from "../../assets/images/Karussell/wedding5.avif";
import wedding6 from "../../assets/images/Karussell/wedding6.avif";

const images = [wedding1, wedding6, wedding5];

function Karussell() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // wechsle alle 4 Sekunden
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.sliderContainer}>
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Slide ${index}`}
          className={`${styles.slide} ${
            index === currentIndex ? styles.active : ""
          }`}
        />
      ))}
    </div>
  );
}

export default Karussell;
